import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { adminList, customerMsgList } from "@/api/customerCenter/customerCenter";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import addErrorPlayer from "./components/addErrorPlayer";
export default {
  name: "customerMsgReview",
  components: {
    addErrorPlayer: addErrorPlayer
  },
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      paramsData: {
        page_size: 10,
        page: 1,
        admin_id: '',
        user_id: '',
        server_id: '',
        role_id: '',
        start_time: '',
        end_time: '',
        key: ''
      },
      tableData: [],
      total: 0,
      page: 1,
      adminDataList: [],
      date: []
    };
  },
  created: function created() {
    this.getAdminList();

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    getAdminList: function getAdminList() {
      var _this2 = this;

      adminList().then(function (res) {
        if (res.code == 200) {
          _this2.adminDataList = res.data;
        }
      });
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1);
    },
    searchClick: function searchClick(e) {
      var _this3 = this;

      this.paramsData.page = e;
      var searchData = JSON.parse(JSON.stringify(this.paramsData));

      if (this.date && Array.isArray(this.date) && this.date.length > 0) {
        this.searchData.start_time = this.date[0];
        this.searchData.end_time = this.date[1];
      } else {
        this.searchData.start_time = "";
        this.searchData.end_time = "";
      }

      this.reqLoading = true;
      customerMsgList(searchData).then(function (res) {
        if (res.code == 200) {
          res.data.data.forEach(function (item) {
            item.customerName = item.conversation.customer_name + (item.sender_type == 'customer' ? '(发送者)' : '(接受者)');
            item.playerName = item.conversation.player_name + (item.sender_type == 'customer' ? '(接受者)' : '(发送者)');
            item.role_id = item.conversation.role_id;
            item.server_id = item.conversation.server_id;
          });
          _this3.tableData = res.data.data || [];
          _this3.total = res.data.total;
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    }
  }
};